import React from "react";
import "./home.css";
import Toast from "../../components/Toast/Toast";
import checkIcon from "../../assets/images/check.svg";
import AnswerInput from "../../components/AnswerInput/AnswerInput";

require("dotenv").config();

export default function Home(props) {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const pageLabel = "Página ";
  const answerLabel = "Exercício ";
  const answerImageLabel = "Ver Imagem";
  const admin = props.admin;
  const answers = props.answers;
  const refreshAnswers = props.refreshAnswers;
  const addAnswer = props.AddAnswer;
  const updateAnswer = props.UpdateAnswer;
  const deleteAnswer = props.DeleteAnswer;
  const [image, setImage] = React.useState();
  const [toastList, setToastList] = React.useState([]);

  function Add(props) {
    if (!props || !props.subject) {
      const newSub = document.querySelector("#newSubject").value;
      const newAnsId = document.querySelector(
        `#add_${answers.page}_new .answerId input`
      ).value;
      const newAns = document.querySelector(
        `#add_${answers.page}_new .answer textarea`
      ).value;
      answers.subjects.push({
        title: newSub,
        answers: [
          {
            id: newAnsId,
            answer: newAns,
            image: !image
              ? null
              : `images/page/${answers.page}/${newSub}/${newAnsId}.${
                  image.name.split(".")[1]
                }`,
          },
        ],
      });

      addAnswer(newSub, newAnsId, newAns, image);

      document.querySelector("#newSubject").value = "";
      document.querySelector(`#add_${answers.page}_new .answerId input`).value =
        "";
      document.querySelector(
        `#add_${answers.page}_new .answer textarea`
      ).value = "";
      setImage(null);
    } else {
      const curSub = props.subject.title;
      const newAnsId = document.querySelector(
        `#add_${answers.page}_${props.subject.title} .answerId input`
      ).value;
      const newAns = document.querySelector(
        `#add_${answers.page}_${props.subject.title} .answer textarea`
      ).value;
      props.subject.answers.push({
        id: newAnsId,
        answer: newAns,
        image: !image
          ? null
          : `images/page/${answers.page}/${curSub}/${newAnsId}.${
              image.name.split(".")[1]
            }`,
      });

      addAnswer(curSub, newAnsId, newAns, image);

      document.querySelector(
        `#add_${answers.page}_${props.subject.title} .answerId input`
      ).value = "";
      document.querySelector(
        `#add_${answers.page}_${props.subject.title} .answer textarea`
      ).value = "";
      setImage(null);
    }
  }

  function Update(subject, answer) {
    const curSub = subject.title;
    const curAnsId = answer.id;
    const newAns = document.querySelector(
      `#ans_${answers.page}_${answer.id} .answer textarea`
    ).value;

    updateAnswer(answer, curSub, curAnsId, newAns, image);

    document.querySelector(
      `#ans_${answers.page}_${answer.id} .answer textarea`
    ).value = "";
    setImage(null);
  }

  function Delete(subject, answer) {
    const curSub = subject.title;
    const curAnsId = answer.id;

    deleteAnswer(subject.answers, curSub, curAnsId);
  }

  function onChangeImg(e) {
    e.preventDefault();
    setImage(e.target.files[0]);
    showToast();
  }

  const showToast = () => {
    setToastList([
      {
        id: 1000,
        title: "Imagem adicionada",
        description: "Preencha o exercício e/ou resposta.",
        backgroundColor: "#5cb85c",
        icon: checkIcon,
      },
    ]);
  };

  function NewAnswer(props) {
    return (
      <li
        id={`add_${answers.page}_${
          props.subject ? props.subject.title : "new"
        }`}
        key={`add_${answers.page}_${
          props.subject ? props.subject.title : "new"
        }`}
        className="answerItem bgAddAnswer"
      >
        <div className="answerGroup">
          <span className="answerId">
            {answerLabel}
            <input type="text" placeholder="Número" />
          </span>
          <span className="answer">
            <textarea className="newAnswer" placeholder="Resposta" />
          </span>
        </div>
        <div className="answerActions">
          <div>
            <label
              htmlFor={`inp_img_${answers.page}_${
                props.subject ? props.subject.title : "new"
              }`}
            >
              <i className="far fa-image warning"></i>
            </label>
            <input
              type="file"
              id={`inp_img_${answers.page}_${
                props.subject ? props.subject.title : "new"
              }`}
              accept=".jpg,.jpeg,.png"
              style={{ display: "none" }}
              onChange={(e) => onChangeImg(e)}
            />
          </div>
          <button onClick={() => Add(props)}>
            <i className="fas fa-plus success"></i>
          </button>
        </div>
      </li>
    );
  }

  function AnswerList(props) {
    return props.subject.answers.map((answer) => {
      return (
        <li
          id={`ans_${answers.page}_${answer.id}`}
          key={`ans_${answers.page}_${answer.id}`}
          className="answerItem"
        >
          <div className="answerGroup">
            <div className="answerId">{answerLabel + answer.id}</div>
            <div className="answer">
              {admin && answer.editing === true ? (
                <AnswerInput answerValue={answer.answer} /> //<input type="text" placeholder="Resposta" value={answer.answer} onChange={(e) => onChangeInput(e,answer)}/>
              ) : answer.image ? (
                <span className="answerSeeImg">{answerImageLabel}</span>
              ) : (
                answer.answer
              )}
            </div>
          </div>
          {admin ? (
            <div className="answerActions">
              {answer.editing === true ? (
                <>
                  <div>
                    <label
                      htmlFor={`inp_img_${answers.page}_${props.subject}_${answer.id}`}
                    >
                      <i className="far fa-image warning"></i>
                    </label>
                    <input
                      type="file"
                      id={`inp_img_${answers.page}_${props.subject}_${answer.id}`}
                      accept=".jpg,.jpeg,.png"
                      style={{ display: "none" }}
                      onChange={(e) => onChangeImg(e)}
                    />
                  </div>
                  <button
                    onClick={() => {
                      answer.editing = false;
                      Update(props.subject, answer);
                      refreshAnswers({ ...answers });
                      // setAnswers({...answers});
                    }}
                  >
                    <i className="fas fa-check success"></i>
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => {
                      answer.editing = true;
                      refreshAnswers({ ...answers });
                      // setAnswers({...answers});
                    }}
                  >
                    <i className="fas fa-pencil-alt primary"></i>
                  </button>
                  <button
                    onClick={() => {
                      const newAnswers = props.subject.answers.filter(
                        (item) => item.id !== answer.id
                      );
                      props.subject.answers = newAnswers;
                      Delete(props.subject, answer);
                      refreshAnswers({ ...answers });
                      // setAnswers({...answers});
                    }}
                  >
                    <i className="far fa-trash-alt error"></i>
                  </button>
                </>
              )}
            </div>
          ) : null}
          {answer.image ? (
            <img
              className="answerImg"
              alt={`${answer.page}_${answer.id}`}
              src={`${SERVER_URL}/${answer.image}`}
            />
          ) : null}
        </li>
      );
    });
  }

  /************************* RENDER PAGE ************************************/
  return (
    <div className="home">
      <div className="pageNumber">
        {answers.page ? (
          pageLabel + answers.page
        ) : (
          <div>
            <div>Nenhuma página encontrada.</div>
            <div className="warning">
              Veja na imagem abaixo onde encontrar o código da página e digite-o
              no campo acima.
            </div>
            <div className="success">Em seguiga, clique no botão Ir.</div>
            <img src="searchCodeExample.jpg" alt="search example" />
          </div>
        )}
      </div>
      {answers.page && answers.subjects.length === 0 && (
        <div className="pageNumber">Nenhuma resposta encontrada.</div>
      )}
      {answers.subjects &&
        answers.subjects.map((subject) => {
          return (
            <div className="subjectGroup" key={subject.title}>
              <div className="subjectHeader">
                <span className="subjectTitle">{subject.title}</span>
              </div>
              <div className="subjectBody">
                <ul className="answerList">
                  <AnswerList key={`ansList_${subject}`} subject={subject} />
                  {admin ? (
                    <NewAnswer key={`newAns_${subject}`} subject={subject} />
                  ) : null}
                </ul>
              </div>
            </div>
          );
        })}
      {admin && props.page ? (
        <div className="subjectGroup">
          <div className="subjectHeader">
            <span className="subjectTitle">
              <input
                id="newSubject"
                type="text"
                placeholder="Digite a nova Matéria"
              />
            </span>
          </div>
          <div className="subjectBody">
            <ul className="answerList">
              <NewAnswer />
            </ul>
          </div>
        </div>
      ) : null}

      <Toast
        toastList={toastList}
        position="bottom-left"
        autoDelete={true}
        dismissTime={4000}
      />
    </div>
  );
}
